var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProjectRoleSelectorDisplay',{attrs:{"role":_vm.localRole,"disabled":_vm.readonly || !_vm.hasPermissionToChangeUsers},on:{"update:role":function($event){_vm.localRole=$event},"updateRole":_vm.updateProjectMemberRole}})
}
var staticRenderFns = []

export { render, staticRenderFns }